import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
// import Joyride from 'react-joyride';
import { useSelector } from 'react-redux';
import { AnagraficaBtn, ListActiveCustomersStyles, SearchBtn } from './ListActiveCustomers.styles';
import { getBrokerActiveCustomers, resetActiveCustomers } from '../../features/activeCustomer/activeCustomerActions';
import PageLoading from '../../common/components/elements/PageLoading';
import Pagination from '../../common/components/elements/Pagination';
import StorageService from '../../services/StorageService';
// import { useTourContext } from '../../context/useTourContext';
import ErrorComponent from '../../common/components/ErrorComponent';
// import { joyrideOptions } from '../../common/utils/joyrideUtils';
// import { handleCallbackListActiveCustomer } from '../../common/utils/joyrideCallbacks';
// import { listActiveCustomerSteps } from '../../common/utils/joyrideSteps';

const Storage = new StorageService();

function ListActiveCustomers() {
  const location = useLocation();
  const navigate = useNavigate();
  const searchDataRef = useRef(null);
  const {
    active_customers: {
      loading, activeCustomers, total_pages, page_number, error,
    },
  } = useSelector((store) => store.activeCustomers);
  const [search, setSearch] = useState({
    search: '',
    search_by: 'active_customer',
  });
  const searchClients = (e) => {
    const trimmedSearch = {
      ...search,
      search: search.search.trim(),
    };
    e.preventDefault();
    getBrokerActiveCustomers(1, trimmedSearch.search, trimmedSearch.search_by);
  };
  // const [steps, setSteps] = useState([]);

  const handleSearch = (e) => {
    setSearch({ ...search, [e.target.name]: e.target.value });
  };

  // const {
  //   setState,
  //   state: { run, showBeacon },
  // } = useTourContext();

  // useEffect(() => {
  //   if (localStorage.getItem('clients') === 'done') {
  //     setState({ run: false });
  //   } else if (loading === false) {
  //     setTimeout(() => {
  //       setState({ run: true });
  //     }, 3000);
  //   }
  // }, [localStorage.getItem('clients'), loading]);

  // const fireNewQuoteTour = () => {
  //   localStorage.removeItem('clients');
  //   setState({ run: true, tourActive: true });
  // };
  // useEffect(() => {
  //   listActiveCustomerSteps(activeCustomers, setSteps);
  // }, [activeCustomers]);

  const customerClickHandler = (customerRow) => {
    if (customerRow.type === 'active_customer') {
      navigate(`/customers/active-customer/${customerRow.id}/contact`);
    } else {
      navigate(`/customers/customer/${customerRow.id}/contact`);
    }
  };

  useEffect(() => {
    getBrokerActiveCustomers();

    return () => {
      resetActiveCustomers();
    };
  }, []);

  searchDataRef.current = activeCustomers;

  useEffect(() => {
    if (location.state !== undefined && location.state !== null) {
      if (location.state.type === 'command') {
        if (location.state.data.page === 'contact-client') {
          setSearch((prev) => ({
            ...prev,
            search: location.state.data.customer,
          }));
          getBrokerActiveCustomers(1, location.state.data.customer, '');

          setTimeout(() => {
            if (searchDataRef.current?.length !== 0) {
              customerClickHandler(searchDataRef.current[0]);
            }
          }, 2000);
        }
      }
    }

    if (location.state !== null) {
      const ls = location.state;

      if (ls.type === 'redirect') {
        const { data } = ls;
        setSearch(data.search);
        getBrokerActiveCustomers(1, data.search, '');

        setTimeout(() => {
          if (searchDataRef.current?.length !== 0) {
            customerClickHandler(searchDataRef.current.find((c) => c.id === data.activeCustomerId));
          }
        }, 2000);
      }
    }
  }, []);

  if (loading) {
    return <PageLoading />;
  }

  return error === null ? (
    <ListActiveCustomersStyles>
      {/* <Joyride
        steps={steps}
        continuous
        showBeacon={showBeacon}
        locale={{
          back: 'Indietro',
          close: 'Chiudi',
          last: 'Fine',
          next: 'Prossima',
          open: 'Apri il modale',
          restart: 'Riavvia il tour ',
          skip: 'Salta',
        }}
        styles={{
          options: joyrideOptions,
          buttonNext: {
            backgroundColor: '#00a651',
            outline: 'none',
          },
          buttonBack: {
            color: '#00a651',
            outline: 'none',
          },
          beaconInner: {
            backgroundColor: '#00a651',
          },
          beaconOuter: {
            borderColor: '#00a651',
            backgroundColor: 'rgba(68 , 154 , 71, 0.4)',
          },
          buttonSkip: {
            outline: 'none',
          },
          buttonClose: {
            outline: 'none',
          },
        }}
        run={run}
        callback={(data) => handleCallbackListActiveCustomer(data, steps, setState)}
        showSkipButton
        showProgress
      /> */}

      {/* Header Section */}
      <div className="mb-4">
        <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3">
          <div>
            <h2 className="mb-1 fw-bold fs-4">Clienti Diretti</h2>
            <p className="text-muted mb-0">Gestisci e visualizza tutti i tuoi clienti diretti</p>
          </div>

          {Storage.getUser().broker_section !== 'E' && (
            <div className="d-flex gap-2 flex-wrap">
              <div className="btn btn-success fw-medium clients-one shadow-sm">
                Clienti Diretti
              </div>
              <Link
                to="/clients/rete"
                className="btn btn-outline-success fw-medium clients-two shadow-sm"
              >
                Clienti Della Rete
              </Link>
            </div>
          )}
          {/* {localStorage.getItem('clients') === 'done' && (
            <button
              onClick={() => fireNewQuoteTour()}
              className="btn btn-outline-success fw-medium shadow-sm"
            >
              Tutorial
            </button>
          )} */}
        </div>
      </div>

      {/* Search Card */}
      <div className="card shadow-sm mb-4 clients-three">
        <div className="card-body p-4">
          <h6 className="fw-semibold mb-3">Cerca Cliente</h6>
          <form className="row g-3">
            <div className="col-12 col-md-5">
              <label htmlFor="search" className="form-label small text-muted mb-1">
                Nome, Cognome, Codice Fiscale o Targa
              </label>
              <input
                id="search"
                type="text"
                name="search"
                value={search.search}
                onChange={handleSearch}
                className="form-control"
                placeholder="Es. Mario Rossi, RSSMRA85M01H501U, AB123CD"
              />
            </div>

            <div className="col-12 col-md-4">
              <label htmlFor="search_by" className="form-label small text-muted mb-1">
                Tipo di Cliente
              </label>
              <select
                id="search_by"
                name="search_by"
                value={search.search_by}
                className="form-select"
                onChange={handleSearch}
              >
                <option value="">Tutti i clienti</option>
                <option value="active_customer">Attivo</option>
                <option value="customer">Non Attivo</option>
              </select>
            </div>

            <div className="col-12 col-md-3">
              <label className="form-label small text-muted mb-1 invisible">Azione</label>
              <SearchBtn onClick={searchClients} className="w-100 shadow-sm">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="me-2"
                  viewBox="0 0 16 16"
                >
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                </svg>
                Cerca
              </SearchBtn>
            </div>
          </form>
        </div>
      </div>

      {/* Results Section */}
      <div className="clients-four">
        {activeCustomers.length !== 0 ? (
          <>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="fw-semibold mb-0">
                Risultati
                <span className="badge bg-success ms-2">{activeCustomers.length}</span>
              </h6>
            </div>

            <div className="card shadow-sm">
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead className="table-light">
                    <tr>
                      <th scope="col" className="fw-semibold">Nome / Ragione Sociale</th>
                      <th scope="col" className="fw-semibold">Cognome</th>
                      <th scope="col" className="fw-semibold">Codice Fiscale</th>
                      <th scope="col" className="fw-semibold text-center">Polizze Emesse</th>
                      <th scope="col" className="fw-semibold">Tipo Cliente</th>
                      <th scope="col" className="fw-semibold text-center">Azioni</th>
                    </tr>
                  </thead>
                  <tbody>
                    {activeCustomers.map((customer, index) => (
                      <tr key={index} className="align-middle">
                        <td className="fw-medium">
                          {customer.gender !== 'G' ? customer.name : customer.business_name}
                        </td>
                        <td>{customer.surname}</td>
                        <td>
                          <code className="text-dark bg-light px-2 py-1 rounded">
                            {customer.fiscal_code}
                          </code>
                        </td>
                        <td className="text-center">
                          <span className="badge bg-light text-dark">
                            {customer.quotations_count}
                          </span>
                        </td>
                        <td>
                          <span className={`badge ${customer.type === 'active_customer' ? 'bg-success' : 'bg-secondary'}`}>
                            {customer.type === 'active_customer' ? 'Attivo' : 'Non Attivo'}
                          </span>
                        </td>
                        <td className="text-center">
                          <AnagraficaBtn className="clients-five">
                            {customer.type === 'active_customer' ? (
                              <Link to={`/clients/${customer.id}`}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="14"
                                  height="14"
                                  fill="currentColor"
                                  className="me-1"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                                </svg>
                                Anagrafica
                              </Link>
                            ) : (
                              <Link to={`/clients-not-active/${customer.id}`}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="14"
                                  height="14"
                                  fill="currentColor"
                                  className="me-1"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                                </svg>
                                Anagrafica
                              </Link>
                            )}
                          </AnagraficaBtn>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        ) : (
          <div className="card shadow-sm">
            <div className="card-body text-center py-5">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="64"
                fill="currentColor"
                className="text-muted mb-3"
                viewBox="0 0 16 16"
              >
                <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                <path fillRule="evenodd" d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z" />
                <path d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" />
              </svg>
              <h5 className="text-muted">Nessun cliente trovato</h5>
              <p className="text-muted mb-0">Prova a modificare i criteri di ricerca</p>
            </div>
          </div>
        )}
      </div>

      {/* Pagination */}
      {activeCustomers.length !== 0 && (
        <div className="mt-4">
          <Pagination
            classNameNav="mt-3"
            onClick={getBrokerActiveCustomers}
            total_pages={total_pages}
            current_page={page_number}
            search={search.search}
            search_by={search.search_by}
          />
        </div>
      )}
    </ListActiveCustomersStyles>
  ) : <ErrorComponent error={error} />;
}

export default ListActiveCustomers;
